import { render } from "./arrow-right.vue?vue&type=template&id=f2e60620"
const script = {}
script.render = render

export default script